import { defineComponent as f, mergeModels as c, useModel as y, useSlots as S, ref as v, provide as h, createElementBlock as r, openBlock as s, mergeProps as V, unref as n, createCommentVNode as _, createVNode as u, createSlots as b, withCtx as m, createElementVNode as L } from "vue";
import g from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/SimpleList/simple-list.js";
import { findChildrenVNodes as B } from "../../util.js";
import N from "../../helpers/Wrap.vue2.js";
import { useOUIAProps as P } from "../../helpers/ouia.js";
const k = ["name", "value", "required"], q = ["aria-label"], C = Symbol("SimpleListValueKey"), O = /* @__PURE__ */ f({
  name: "PfSimpleList",
  __name: "SimpleList",
  props: /* @__PURE__ */ c({
    name: {},
    required: { type: Boolean },
    ariaLabel: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    modelValue: { type: [String, Number, Boolean, Object, null], default: null },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(l) {
    const o = l, d = P({ id: o.ouiaId, safe: o.ouiaSafe }), t = y(l, "modelValue"), a = S(), i = v(!1);
    h(C, t);
    function p() {
      const e = a.default ? B(a.default({})) : [];
      return i.value = e.length === 0 ? !1 : typeof e[0].type == "object" && e[0].type.name === "PfSimpleListGroup", e;
    }
    return (e, I) => (s(), r("div", V(n(d), {
      class: n(g).simpleList
    }), [
      e.name ? (s(), r("input", {
        key: 0,
        type: "hidden",
        name: e.name,
        value: t.value,
        required: e.required
      }, null, 8, k)) : _("", !0),
      u(N, null, b({
        default: m(() => [
          u(p)
        ]),
        _: 2
      }, [
        i.value ? void 0 : {
          name: "with",
          fn: m(() => [
            L("ul", {
              class: "pf-v6-c-simple-list__list",
              role: "list",
              "aria-label": e.ariaLabel
            }, null, 8, q)
          ]),
          key: "0"
        }
      ]), 1024)
    ], 16));
  }
});
export {
  C as SimpleListValueKey,
  O as default
};
